// extracted by mini-css-extract-plugin
module.exports = {"container":"appPromoButton_container__Bt16h","button":"appPromoButton_button__JNNL_","link":"appPromoButton_link__qSw_4","close":"appPromoButton_close__FpnMq"};